module.exports = __webpack_public_path__ + "img/module2_item1.6aac4980.png";